<template>
  <section class="flex flex-col sm:justify-between items-center sm:flex-row mt-12 sm:mt-10">
    <div class="w-full md:w-1/3 text-left">
      <h1 class="text-4xl md:text-5xl font-bold text-gray-900 dark:text-primary-light">
        {{ $t('greeting') }}
      </h1>
      <h2 class="text-2xl font-semibold text-gray-800 mt-2 dark:text-primary-light">
        {{ $t('subtitle') }}
      </h2>
      <p class="text-base text-gray-600 mt-4 leading-relaxed">
        {{ $t('aboutContent') }}
      </p>
      <router-link
        :class="theme === 'light' ? 'router-link-light bg-primary-light text-ternary-dark hover:bg-primary-dark hover:text-white' : 'router-link-dark bg-primary-dark text-white hover:bg-primary-light hover:text-ternary-dark'"
        to="/projects"
        class="mt-4 inline-block px-6 py-3 font-general-medium text-lg rounded-lg shadow-md transition duration-300"
      >
        {{ $t('viewProjects') }}
        <!-- <i data-feather="arrow-right" class="ml-2"></i> -->
      </router-link>
    </div>

    <!-- Banner right illustration -->
    <div class="w-full md:w-2/3 text-right float-right">
      <img v-if="theme === 'light'" src="@/assets/images/lBanner-2.png" alt="Developer" class="w-full" />
      <img v-else src="@/assets/images/lBanner-2.png" alt="Developer" class="w-full" />
    </div>
  </section>
</template>

<script>
import feather from 'feather-icons';

export default {
  name: 'AppBanner',
  data() {
    return {
      theme: '',
    };
  },
  created() {
    this.theme = localStorage.getItem('theme') || 'light';
  },
  mounted() {
    feather.replace();
    this.theme = localStorage.getItem('theme') || 'light';
  },
  updated() {
    feather.replace();
  }
}
</script>

<style scoped>
.router-link-light {
  background-color:  #f0f0f0; /* Adjust to a lighter shade */
}
.router-link-dark {
  background-color: #999999; /* Adjust to a darker shade */
}

</style>